'use client';

import { userPageFields } from '@/lib/croCheckout';
import { GTMEventType } from '@/lib/GTMEventType';
import {
  getPersistedCampaignParams,
  persistCampaignParamsFromURL,
} from '@/lib/persistCampaignParams';
import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect, useRef } from 'react';

export default function GTMPageviewReporter() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const lastReportedUrl = useRef<string | null>(null);

  useEffect(() => {
    persistCampaignParamsFromURL();

    const finalParams = new URLSearchParams(searchParams.toString());
    const persistedParams = getPersistedCampaignParams();
    Object.entries(persistedParams).forEach(([key, value]) => {
      finalParams.set(key, value);
    });

    const finalQueryString = finalParams.toString();
    const finalUrl = pathname + (finalQueryString ? `?${finalQueryString}` : '');

    if (finalUrl !== lastReportedUrl.current) {
      const user = userPageFields();
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'user_context',
        ...user,
      });
      window.dataLayer.push({
        event: GTMEventType.PAGE_VIEW,
        page: finalUrl,
        ...user,
      });
      console.log('📄 GTM pageview gönderildi:', finalUrl);
      lastReportedUrl.current = finalUrl;
    }
  }, [pathname, searchParams]);

  return null;
}
